import { eventsLoadedLiveNotification } from './CalendarNotification.locstring.json';
import loc, { format } from 'owa-localize';
import * as React from 'react';
import dateRangeToDisplayString from 'owa-timestrip/lib/utils/dateRangeToDisplayString';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';
import { LiveNotification } from 'owa-live-notification';
import { observer } from 'mobx-react-lite';

/**
 * A control for a region that gives aria live updates whenever the number of selected calendars, the number of calendar events,
 * or the selected date range changes
 */
const CalendarNotification = observer(function CalendarNotification(props: {}) {
    let alertString = loc(eventsLoadedLiveNotification);
    let alert = format(
        alertString,
        surfaceStore.calendarItems.length,
        getSelectedCalendars().length,
        dateRangeToDisplayString(surfaceStore.dateRange, surfaceStore.dateRangeType)
    );

    return <LiveNotification message={alert} atomic={true} />;
});
export default CalendarNotification;
